import { render, staticRenderFns } from "./headInfoConfirmation.vue?vue&type=template&id=bdcf2400&scoped=true&"
import script from "./headInfoConfirmation.vue?vue&type=script&lang=js&"
export * from "./headInfoConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./headInfoConfirmation.vue?vue&type=style&index=0&id=bdcf2400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcf2400",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VSimpleTable})
